module.exports = __webpack_public_path__ + "img/topicChildProducts.a3e5cd9e.png";